import "./DS.scss";

export interface DSPlaceholderAPI {
  readonly getElement: () => HTMLElement;
  readonly setVisible: (visible: boolean) => void;
  readonly destroy: () => void;
}

export const createDSPlaceholder = (): DSPlaceholderAPI => {
  const container = document.createElement("div");
  container.className = "dedicated-placeholder dedicated-placeholder--ds";

  container.innerHTML = `
    <div class="dedicated-placeholder__header">
      <h2 class="dedicated-placeholder__title">Design System</h2>
      <p class="dedicated-placeholder__subtitle">
        Centralized space for tokens, components, and design assets. Coming soon.
      </p>
    </div>
    <div class="dedicated-placeholder__body">
      <div class="dedicated-placeholder__panel">
        <p class="dedicated-placeholder__text">
          Preview design tokens, component palettes, and usage guidelines here.
        </p>
        <p class="dedicated-placeholder__text">
          This placeholder keeps the layout warm while we wire the real DS module.
        </p>
      </div>
    </div>
  `;

  const setVisible = (visible: boolean) => {
    container.style.display = visible ? "flex" : "none";
  };

  const destroy = () => {
    container.remove();
  };

  return {
    getElement: () => container,
    setVisible,
    destroy,
  };
};
